import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const CODE_TEXT = {
  INVITE_NOT_ALLOWED: {
    de: "Diese Anfrage ist nicht möglich. Du kannst nur Handwerker erneut anfragen, mit denen du einen Auftrag abgeschlossen hast.",
    en: "This request is not possible. You can only re-hire craftsmen you have completed a job with.",
    fr: "Cette demande n'est pas possible. Vous ne pouvez solliciter à nouveau que des artisans avec lesquels vous avez terminé une mission.",
    ar: "هذا الطلب غير ممكن. يمكنك فقط التعاقد مجدداً مع حرفيين أنهيت معهم عملاً.",
  },
  WRONG_PASSWORD: {
    de: "Das Passwort stimmt nicht.", en: "The password is wrong.", fr: "Le mot de passe est incorrect.", ar: "كلمة المرور غير صحيحة.",
  },
  ACTIVE_JOB: {
    de: "Du hast noch einen laufenden Auftrag. Bitte schließe ihn zuerst ab.", en: "You still have a job in progress. Please complete it first.",
    fr: "Vous avez encore une mission en cours. Terminez-la d'abord.", ar: "لديك عمل جارٍ. يرجى إنهاؤه أولاً.",
  },
  TOO_MANY_ATTEMPTS: {
    de: "Zu viele Fehlversuche. Bitte in 15 Minuten erneut versuchen.",
    en: "Too many failed attempts. Please try again in 15 minutes.",
    fr: "Trop de tentatives échouées. Réessayez dans 15 minutes.",
    ar: "محاولات فاشلة كثيرة. حاول مجدداً بعد 15 دقيقة.",
  },
  CONTACT_INFO_NOT_ALLOWED: {
    de: "Bitte keine Telefonnummern, E-Mail-Adressen oder Links angeben – auch nicht umschrieben. Der Kontakt läuft über MyMoalem; nach dem Zuschlag tauscht ihr die Daten aus. Bitte ändere den Text.",
    en: "Please do not include phone numbers, email addresses or links – not even in disguised form. Contact runs through MyMoalem; you exchange details after the job is awarded. Please change the text.",
    fr: "Merci de ne pas indiquer de numéros de téléphone, d'e-mails ou de liens – même déguisés. Le contact passe par MyMoalem ; vous échangez vos coordonnées après l'attribution. Veuillez modifier le texte.",
    ar: "يرجى عدم كتابة أرقام الهاتف أو البريد الإلكتروني أو الروابط – حتى بشكل مموّه. التواصل يتم عبر MyMoalem وتتبادلون البيانات بعد إسناد العمل. يرجى تعديل النص.",
  },
  ACCOUNT_BLOCKED: {
    de: "Dieses Konto wurde gesperrt, weil gegen die Richtlinien von MyMoalem verstoßen wurde. Der Zugang steht nicht mehr zur Verfügung.",
    en: "This account has been blocked for violating the MyMoalem guidelines. Access is no longer available.",
    fr: "Ce compte a été bloqué pour non-respect des règles de MyMoalem. L'accès n'est plus disponible.",
    ar: "تم حظر هذا الحساب لمخالفة قواعد MyMoalem. لم يعد الدخول متاحاً.",
  },
  EMAIL_BLOCKED: {
    de: "Diese E-Mail-Adresse wurde gesperrt und kann bei MyMoalem nicht verwendet werden.",
    en: "This email address has been blocked and cannot be used on MyMoalem.",
    fr: "Cette adresse e-mail a été bloquée et ne peut pas être utilisée sur MyMoalem.",
    ar: "تم حظر هذا البريد الإلكتروني ولا يمكن استخدامه في MyMoalem.",
  },
  INVALID_CITY: { de: "Ungültige Stadt.", en: "Invalid city.", fr: "Ville invalide.", ar: "مدينة غير صالحة." },
  INVALID_CATEGORY: { de: "Ungültige Kategorie.", en: "Invalid category.", fr: "Catégorie invalide.", ar: "فئة غير صالحة." },
  INVALID_TRADE: { de: "Ungültiges Gewerk.", en: "Invalid trade.", fr: "Métier invalide.", ar: "مهنة غير صالحة." },
  INVALID_IMAGE_URL: { de: "Ungültige Bildadresse.", en: "Invalid image address.", fr: "Adresse d'image invalide.", ar: "عنوان صورة غير صالح." },
};

function codeText(code) {
  const entry = CODE_TEXT[code];
  if (!entry) return null;
  let lang = "fr";
  try { lang = localStorage.getItem("lang") || "fr"; } catch (e) { /* ignore */ }
  return entry[lang] || entry.en;
}

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return codeText(detail) || detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;